<script lang="ts">
  import Trustpilot from "$components/trustpilot/testimonials/carousel.svelte";

  export let hideSecondary = false;
  export let vertical = false;
  export let className = "";
  export let noBg = false;
  export let theme = "light";
  export let none = false;
</script>

<div class={`banner-wrapper ${className}`} class:vertical class:no-bg={noBg} class:light={theme === "light"}>
  <div class={`grid title sf-800`} class:hide={!vertical}>Football Ticket Pad Benefits</div>
  <div class="grid comment sf-600">
    <i />
    24/7 Customer Support
    <span class:hide={hideSecondary}>Need help purchasing your tickets? Our team are available around the clock.</span>
  </div>
  <div class="grid lock sf-600">
    <i />
    Secure Checkout Process
    <span class:hide={hideSecondary}>
      Your online payment always is safe with our state-of-the-art secure checkout.
    </span>
  </div>
  <div class="grid clock sf-600">
    <i />
    Last Minute Bookings
    <span class:hide={hideSecondary}>Secure tickets last minute. Don’t miss the game.</span>
  </div>
  <div class="grid pad sf-600">
    <i />
    Large Ticket Inventory
    <span class:hide={hideSecondary}>Find the perfect tickets and book together.</span>
  </div>
  {#if vertical && !none}
    <hr />
    <div class="trustpilot">
      {#if $$slots.vertical}
        <slot name="vertical" />
      {:else}
        <Trustpilot theme="dark" height="300px" width="100%" />
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .banner-wrapper {
    display: none;
    color: #fff;

    @include desktop {
      display: grid;
      grid-template-columns: 23% 23% 23% 23%;
      border: 1px solid #e1e0e0;
      border-radius: 0.3125em;
      gap: 1.88em;
      padding: 2em;
      border-radius: 5px;
      height: calc(100% - 50px);
      &:not(.no-bg) {
        background:
          linear-gradient(180deg, rgba(9, 10, 19, 0.75) 0%, rgba(15, 17, 31, 0.8) 70.48%),
          url(./usp-banner.jpg) lightgray 50% / cover no-repeat;
      }
    }

    &.vertical {
      grid-template-columns: 1fr;
      padding: 0.77em;

      @media (min-width: 1200px) {
        width: 370px;
      }
    }

    &.light {
      color: #000;
      i {
        filter: invert(1) sepia(1) saturate(1) hue-rotate(180deg);
      }
    }

    > div {
      grid-template-columns: 1fr;
      padding: 0 1.56em;
      gap: 0.56em;
      justify-self: center;
      text-align: center;

      i {
        justify-self: center;
        display: inline-block;
        background-size: cover;
        background-repeat: no-repeat;
      }

      span {
        font-weight: 400;
        font-size: 16px;
      }
    }

    .title {
      font-size: 1.5625em;
      line-height: 30px;
      height: 50px;
      padding: 26px 0 0;
      margin-bottom: 5px;
    }

    .comment {
      font-size: 1.125em; // 18px;
      i {
        background: url(./comment.svg);
        width: 1.67em;
        height: 1.67em;
      }
    }

    .lock {
      font-size: 1.125em; // 18px;
      i {
        background: url(./lock.svg);
        width: 1.27em;
        height: 1.67em;
      }
    }

    .clock {
      font-size: 1.125em; // 18px;
      i {
        background: url(./clock.svg);
        width: 1.56em;
        height: 1.8em;
      }
    }

    .pad {
      font-size: 1.125em; // 18px;
      margin-bottom: 20px;
      i {
        background: url(./pad.svg);
        width: 1.54em;
        height: 1.67em;
      }
    }
  }

  .hide {
    display: none;
  }
</style>
